<template>
  <div class="cpntainer">
    <div
      id="3dsForm"
      class="form3ds"
    />
  </div>
</template>
<script lang="ts">
import { REMITTAMCES_TO_SIM, STATUS_ERROR } from '@/constant';
import { computed, defineComponent, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';


export default defineComponent({
  setup() {
    const wd: Window = window;
    
    const store = useStore();
    const router = useRouter();
    
    const jsSDK = computed(() => store.getters['JsSDK']);
  
    const create3dsForm = async () => {
      try {
        const JSPayResult = await wd.FreedomPaySDK.confirmInIframe(jsSDK.value, '3dsForm');
         
        if (JSPayResult && JSPayResult.payment_status) {
          const paymentID = {
            transaction_id: jsSDK.value.transactionId,
            order_id: JSPayResult.order_id,
            payment_id: JSPayResult.payment_id
          };

          const result = await store.dispatch('simRemittances/confirmRemittances', paymentID);
          
          if (result && result.status === STATUS_ERROR ) {
            router.push({ name: 'service-status',
              params: {
                failure_description: result.message,
                paymentType: REMITTAMCES_TO_SIM,
                status: STATUS_ERROR
              } 
            });
         
            return;
          }
          
          router.push({ name: 'service-status',
            params: { 
              payment_id: result.payment.id,
              order_id: JSPayResult.order_id,
              paymentType: REMITTAMCES_TO_SIM,
              status: JSPayResult.payment_status
            } 
          });
        }
      } catch (JSErrorObject) {
        return JSErrorObject;
      }
    };
  
    onMounted(() => {
      create3dsForm();
    });
  
    return {};
  },
});
</script>
<style lang="scss" scoped>
.form3ds{
  height: 700px;
}
</style>
